import styled from "styled-components";

export const GuestNameItem = styled.span`
  font-family: "Poppins-SemiBold";
  font-size: 18px;
  display: flex;
  align-items: center;
`;

export const GuestButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Dot = styled.span`
  background-color: #31D5BC;
  width: 6px;
  height: 6px;
  border-radius: 50px;
  margin-right: 5px;
  display: inline-block;
`;
